// extracted by mini-css-extract-plugin
export default {"tabContainer":"TabView_tabContainer__vMDWn","tab":"TabView_tab__P1A5n","activeTab":"TabView_activeTab__mhD7g"};